import { ScriptAdapter } from "../script/ScriptAdapter";
export class StatisticsAdapter extends ScriptAdapter {
    init(data) {
    }
    trackPage(pathName, pageTitle = '', pageLocation = '') {
        logger.warn('no page tracker set');
    }
    trackEvent(event) {
        logger.warn('no event tracker set');
    }
}
